export class MbmError {
  statusCode?: number;
  validationErrorCode?: number;
  validationMessage?: string;
  handled?: boolean;
  logError?: boolean;
  originalError?: unknown;
}
